import clsx from "clsx";

const Loading = ({ noAnimation }: { noAnimation?: boolean }) => {
  return (
    <div className="group relative w-[320px] flex flex-col row-span-1 col-span-1 rounded-[8px] overflow-hidden mx-auto">
      <div className="h-[222px] relative w-full bg-loading-gray" />
      <div className="bg-[#F6F7F8] h-[73px] w-full">
        <div
          className={clsx(
            !noAnimation && "animate-pulse ",
            "rounded-[2px] w-[126px] h-[17px] bg-gradient-to-r from-white to-loading-gray ml-[15px] mt-[16px] mb-[8px]"
          )}
        />
        <div
          className={clsx(
            !noAnimation && "animate-pulse ",
            "rounded-[2px] w-[126px] h-[17px] bg-gradient-to-r from-white to-loading-gray ml-[15px] mt-[16px] mb-[8px]"
          )}
        />
      </div>
    </div>
  );
};

export default Loading;
